<div class="fulfillmentLanding seed-return-wrapper">
  <div class="sraLandingPage">
    <div class="row">
      <div class="col-md-12 col-lg-12 margin-l0 TopSec">
        <h3>
          SRA Summer Fill Order
        </h3>
      </div>
    </div>
    <div class="form-sec">
      <div class="row margin-t10 margin-b10 margin-r0">
        <div class="col-sm-12  col-md-9 col-lg-9 col-xl-10 smallPadRgt0 margin-l0">
          <div class="row search-box-outer ">
            <div class="col-4 col-md-4 col-lg-3 padding-r0 category-drop-outer borderRight">

              <div class="category-dropdown material-select">
                <ng-select [items]="selectedTabIndex === 0 ? searchTypeList : searchPlaceTypeList" 
                           name="ddlProductSearch"
                           [(ngModel)]="selectedValue"
                           [virtualScroll]="true"
                           [closeOnSelect]="true"
                           [selectOnTab]="true"
                           [clearable]="false"
                           bindValue="value"
                           labelForId="name"
                           [searchable]="false"
                           (change)="retainFilter(null, ' ')">
                </ng-select>
              </div>
            </div>
            <div class="col-8 col-md-8 col-lg-9 padding-l4 padding-r0 ">
              <div class="row material-select seed-search-filter">
                <ng-select #status name="ddlStatusSearch" *ngIf="selectedValue === 'Status'"
                           [items]="selectedTabIndex === 0 ? statusList : processingStatusList"
                           placeholder="Search..."
                           class="custom-select-grower"
                           [multiple]="true"
                           [hideSelected]="true"
                           [(ngModel)]="productFilters.Status"
                           [virtualScroll]="true"
                           bindLabel="value"
                           bindValue="value"
                           [closeOnSelect]="true"
                           [searchFn]="filterSearchFn"
                           (change)="retainFilter(status,'Status')">
                  <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                    <div class="dropdown-template">
                      <div class="row">
                        <div class="col-md-8">
                          <p class="name">
                            {{item.value}}
                          </p>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                    <div class="ng-option disabled">
                      No data found for "{{searchTerm}}"
                    </div>
                  </ng-template>
                </ng-select>
                <ng-select #cropYear name="ddlCropYearSearch" *ngIf="selectedValue === 'Crop Year'"
                           [items]="cropYearList"
                           placeholder="Search..."
                           class="custom-select-grower"
                           [multiple]="true"
                           [hideSelected]="true"
                           [(ngModel)]="productFilters.CropYear"
                           [virtualScroll]="true"
                           bindLabel="value"
                           bindValue="value"
                           [closeOnSelect]="true"
                           [searchFn]="filterSearchFn"
                           (change)="retainFilter(cropYear,'CropYear')">
                  <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                    <div class="dropdown-template">
                      <div class="row">
                        <div class="col-md-8">
                          <p class="name">
                            {{item.value}}
                          </p>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                    <div class="ng-option disabled">
                      No data found for "{{searchTerm}}"
                    </div>
                  </ng-template>
                </ng-select>
                <ng-select #itemNumber name="ddlItemNoSearch" *ngIf="selectedValue === 'Item Number'"
                           [items]="itemList"
                           placeholder="Search..."
                           class="custom-select-grower"
                           [multiple]="true"
                           [hideSelected]="true"
                           [(ngModel)]="productFilters.ItemNumber"
                           [virtualScroll]="true"
                           bindLabel="value"
                           bindValue="value"
                           [closeOnSelect]="true"
                           [searchFn]="filterSearchFn"
                           (change)="retainFilter(itemNumber,'ItemNumber')">
                  <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                    <div class="dropdown-template">
                      <div class="row">
                        <div class="col-md-8">
                          <p class="name">
                            {{item.value}}
                          </p>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                    <div class="ng-option disabled">
                      No data found for "{{searchTerm}}"
                    </div>
                  </ng-template>
                </ng-select>

                <div #productSearchd *ngIf="selectedValue === 'Product Name'" class="wide100">
                  <div class="search-box-outer">
                    <div class="search-box wide100">
                      <span class="search-icon">
                        <i class="fas fa-search"></i>
                      </span>
                      <div class="select-container">
                        <input (keyup.enter)="retainFilter(null, ' ');getSearchData();" [(ngModel)]="productFilters.ProductName"
                               placeholder="Search..." type="text">
                      </div>
                    </div>
                  </div>
                </div>
                <div #productSearch *ngIf="selectedValue === 'Account Name'" class="wide100">
                  <div class="search-box-outer">
                    <div class="search-box wide100">
                      <span class="search-icon">
                        <i class="fas fa-search"></i>
                      </span>
                      <div class="select-container">
                        <input (keyup.enter)="retainFilter(null, ' ');getSearchData();" [(ngModel)]="productFilters.AccountName"
                               placeholder="Search..." type="text">
                      </div>
                    </div>
                  </div>
                </div>
                <div #productSearch *ngIf="selectedValue === 'Account Number'" class="wide100">
                  <div class="search-box-outer">
                    <div class="search-box wide100">
                      <span class="search-icon">
                        <i class="fas fa-search"></i>
                      </span>
                      <div class="select-container">
                        <input (keyup.enter)="retainFilter(null, ' ');getSearchData();" [(ngModel)]="productFilters.TxtAccountNo"
                               placeholder="Search..." type="text" pattern="^[0-9, ]+$" #accountCtrl>
                      </div>
                    </div>
                  </div>
                </div>

                <div *ngIf="selectedValue == 'Request ID'" class="wide100">
                  <div class="search-box-outer">
                    <div class="search-box wide100">
                      <span class="search-icon">
                        <i class="fas fa-search"></i>
                      </span>
                      <div class="select-container">
                        <input (keyup.enter)="retainFilter(null, ' ');getSearchData();" [(ngModel)]="productFilters.RequestID"
                               placeholder="Search..." type="text">
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngIf="selectedValue == 'Order ID'" class="wide100">
                  <div class="search-box-outer">
                    <div class="search-box wide100">
                      <span class="search-icon">
                        <i class="fas fa-search"></i>
                      </span>
                      <div class="select-container">
                        <input (keyup.enter)="retainFilter(null, ' ');getSearchData();" [(ngModel)]="productFilters.WebOrderNumber"
                               placeholder="Search..." type="text">
                      </div>
                    </div>
                  </div>
                </div>

                <div *ngIf="selectedValue == 'Customer PO#'" class="wide100">
                  <div class="search-box-outer">
                    <div class="search-box wide100">
                      <span class="search-icon">
                        <i class="fas fa-search"></i>
                      </span>
                      <div class="select-container">
                        <input (keyup.enter)="retainFilter(null, ' ');getSearchData();" [(ngModel)]="productFilters.CustomerPO"
                               placeholder="Search..." type="text">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-md-3 col-lg-3 col-xl-2 search-btn-outer text-right xs-pl-0 lg-pl-60  md-pl-40 md-pr-0">
          <div class="row">
            <div class="col-12">
              <div class="search-btn xs-full-width mobile-pl-5">
                <button mat-raised-button class="btns" (click)="retainFilter(null, ' ');getSearchData();" color="primary">Search</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 padding-r0">
          <div class="chips-sec">
            <div class="row selected-chip">
              <div class="col-sm-6 col-md-8 padding-l0">
                <div>
                  <mat-chip-set>
                    <mat-chip selected *ngFor="let filterValue of filterValueList">
                      {{filterValue}}
                      <a href="Javascript:void(0);" (click)="clearFilter(filterValue)">
                        <i class="fas fa-times text-right"></i>
                      </a>
                    </mat-chip>
                  </mat-chip-set>
                </div>
              </div>
              <div class="col-sm-3 col-md-2 text-right padding-r30" *ngIf="filterValueList?.length > 0">
                <a href="Javascript:void(0);" class="clearAll" (click)="clearAllFilter(false)">Clear All</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 legend-outer sraCreateOrder">
        <mat-tab-group disableRipple [animationDuration]="'400ms'" class="matTabs prepayLandingTab" (selectedTabChange)="tabChanged($event)" [selectedIndex]="selectedTabIndex">

          <mat-tab>
            <ng-template mat-tab-label>
              <i class="icon-ico-dealer_icon pt-1 xs-mr-5" aria-hidden="true"></i>
              <div class="tab-head">
                <h4>
                 Open Requests
                </h4>
              </div>
            </ng-template>
            <div class="fulfill-top-sec">
              <div class="row listing-action-items">
                <div class="col-12  d-flex justify-content-end">
                  <div class="display-ib wAuto">
                    <mat-paginator #openRequestPaginator [pageSize]="masterConstants.PAGE_SIZE" [pageSizeOptions]="masterConstants.PAGE_SIZE_OPTIONS"></mat-paginator>
                  </div>
                  <button mat-raised-button *ngIf="hasReviewAccess" class="btns create-blanket-btn ml-3" color="primary" (click)="navigateToReviewApprove(false)">
                    Review Request
                  </button>
                  <button mat-raised-button *ngIf="hasReviewApproveAccess && hasSecurityApproveAccess" class="btns create-blanket-btn ml-3" color="primary" (click)="navigateToReviewApprove(true)">
                    Review/Approve Request
                  </button>
                  <button mat-raised-button *ngIf="hasRequestAccesse && hasSraEditAccess" class="btns create-blanket-btn ml-3" color="primary" (click)="createNewOrder()">
                    Create New Request
                  </button>
                </div>
              </div>
            </div>
            <div class="tableContainer activeReturnRequest">
              <table mat-table #openRequestTable [dataSource]="openRequestDataSource" matSort #openRequestSort matSortDirection="desc" class="matTables">
                <ng-container matColumnDef="returnRequestID">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="returnId  text-center">Request ID</th>
                  <td mat-cell *matCellDef="let element" class="text-left">
                    <div *ngIf ="readOnlyAccess || hasSraEditAccess" class="order-info handCursor" (click)="navigateOrderDetail(element,'open')">
                      <u>
                        <p class="accNo">
                          {{element.requestID}}
                        </p>
                      </u>
                    </div>

                    <div *ngIf="!readOnlyAccess && !hasSraEditAccess" style="text-decoration: none;">
                      <u>
                        <p class="accNo">
                          {{element.requestID}}
                        </p>
                      </u>
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="customerPO">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="customerPO  text-center">Customer PO#</th>
                  <td mat-cell *matCellDef="let element" class="text-center"> {{element.customerPO}} </td>
                </ng-container>
                <ng-container matColumnDef="shipToAccount">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center">Ship To Account</th>
                  <td mat-cell *matCellDef="let element" class="order-info defaultCursor">
                    <div class="order-info">
                      <p class="accName">
                        {{element.shipToAccountName}}
                      </p>
                      <p class="accAddress"> {{element.shipToAccountAddress1}}, {{element.shipToCity}}, {{element.shipToState}} {{element.shipToZipCode}}</p>
                      <p class="accName">
                        Account #: {{element.shipToAccountNo}}
                      </p>
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="deliverToAccount">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center">Deliver To Account</th>
                  <td mat-cell *matCellDef="let element" class="order-info defaultCursor">
                    <div class="order-info">
                      <p *ngIf ="element.deliverToAccountNo" class="accName">
                        {{element.deliverToAccountName}}
                      </p>
                      <p class="accAddress" *ngIf ="element.deliverToAccountNo"> {{element.deliverToAccountAddress1}}, {{element.deliverToCity}}, {{element.deliverToState}} {{element.deliverToZipCode}}</p>
                      <p class="accName" *ngIf ="element.deliverToAccountNo">
                        Account #: {{element.deliverToAccountNo}}
                      </p>
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="requestDate">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="requestDate  text-center">Request Date</th>
                  <td mat-cell *matCellDef="let element" class="text-left"> {{element.requestDate | date:'MM/dd/yyyy'}} </td>
                </ng-container>
                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="status text-center"> Status </th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    <span class="statusMsg">
                      {{getStatusText(element.status)}}
                    </span>
                  </td>
                </ng-container>
                <ng-container matColumnDef="contextMenu">
                  <th mat-header-cell *matHeaderCellDef class="actionBtn">&nbsp;</th>
                  <td mat-cell *matCellDef="let element" class="text-left">
                    <div *ngIf="element.hasAllOpenLines && hasSraEditAccess">
                      <button mat-button [matMenuTriggerFor]="beforeMenu1" class="context-menu">
                        <i class="fas fa-ellipsis-v"></i>
                      </button>
                      <mat-menu #beforeMenu1="matMenu" xPosition="before" class="context-meun-dropdown">
                        <button mat-menu-item (click)="deleteOrder(element.requestID)">Delete</button>
                      </mat-menu>
                    </div>
                  </td>
                  <td mat-footer-cell *matFooterCellDef class="xs-none">  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="openRequestColumns;sticky:true;"></tr>
                <tr mat-row *matRowDef="let row; columns: openRequestColumns;"></tr>
              </table>
              <div *ngIf="openRequestList == undefined || openRequestList.length == 0" class="noDataMsg">
                <p class="padding-b47">No Record Found.</p>
              </div>
            </div>
          </mat-tab>

          <mat-tab *ngIf="isShowPlaceOrderTab">
            <div class="col-md-2">
              <ng-template mat-tab-label>
                <i class="icon-ico-grower_icon pt-1 xs-mr-5" aria-hidden="true"></i>
                <div class="tab-head">
                  <h4>
                    Placed Orders
                  </h4>
                </div>
              </ng-template>
            </div>

            <div class="fulfill-top-sec">
              <div class="row listing-action-items">
                <div class="col-12 d-flex justify-content-end">
                  <div class="display-ib wAuto">
                    <mat-paginator #placedRequestPaginator [pageSize]="masterConstants.PAGE_SIZE" [pageSizeOptions]="masterConstants.PAGE_SIZE_OPTIONS"></mat-paginator>
                  </div>
                  <button mat-raised-button *ngIf="hasReviewAccess" class="btns create-blanket-btn ml-3" color="primary" (click)="navigateToReviewApprove(false)">
                    Review Request
                  </button>
                  <button mat-raised-button *ngIf="hasReviewApproveAccess && hasSecurityApproveAccess" class="btns create-blanket-btn ml-3" color="primary" (click)="navigateToReviewApprove(true)">
                    Review/Approve Request
                  </button>
                  <button mat-raised-button *ngIf="hasRequestAccesse && hasSraEditAccess" class="btns create-blanket-btn ml-3" color="primary" (click)="createNewOrder()">
                    Create New Request
                  </button>
                </div>
              </div>
            </div>

            <div class="tableContainer draftReturnRequest">
              <table mat-table #placedRequestTable [dataSource]="placedRequestDataSource" matSort #placedRequestSort matSortDirection="desc" class="matTables">
                <ng-container matColumnDef="webOrderNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="shipToLocation">Order ID</th>
                  <td mat-cell *matCellDef="let element">
                    <div class="d-block d-sm-block d-md-none sm-block">Order ID</div>
                    <div (click)="viewOrderDetail(element,false,'placed')">
                      <a>{{element.webOrderNumber}}</a>
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="purchaseOrderNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="webOrderNumber text-center ">Customer PO#</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    <div class="d-block d-sm-block d-md-none sm-block">Customer PO#</div>
                    <div>
                      {{element.purchaseOrderNumber}}
                    </div>
                  </td>
                </ng-container>

                <ng-container matColumnDef="orderCreateDate">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="orderCreateDate  text-center  ">
                    Order Date
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    <div class="d-block d-sm-block d-md-none">Order Date</div>
                    {{element.orderCreateDate | date:'MM/dd/yyyy'}}
                  </td>
                </ng-container>

                <ng-container matColumnDef="accountNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="accountNumber  text-center  ">Account #</th>
                  <td mat-cell *matCellDef="let element" class="text-center"> <div class="d-block d-sm-block d-md-none sm-block">Account #</div> {{element.accountNumber}} </td>
                </ng-container>
                <ng-container matColumnDef="accountName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="locationDetails text-center ">   Account Name </th>
                  <td mat-cell *matCellDef="let element">
                    <div class="d-block d-sm-block d-md-none sm-block">Account Name</div>
                    <div class="order-info defaultCursor">
                      <p class="grower-name">
                        {{element.accountName}}
                      </p>
                      <p>{{element.accountAddress1 || element.accountAddress2}}, {{element.accountCity}}, {{element.accountState}} {{element.accountZipCode}}</p>
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef class="status text-center placedStatus"> Status </th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    <div class="d-block d-sm-block d-md-none">Status</div>
                    <div class="relative fix-status-alignment">
                      <div class="width-status">
                        <span class="">{{element.StatusList[0]}}</span>
                      </div>
                    </div>
                  </td>
                </ng-container>

                <ng-container matColumnDef="contextMenu">
                  <th mat-header-cell *matHeaderCellDef class="actionBtn ">&nbsp;</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    <div>
                      <button mat-button [matMenuTriggerFor]="beforeMenu1" class="context-menu">
                        <i class="fas fa-ellipsis-v"></i>
                      </button>
                      <mat-menu #beforeMenu1="matMenu" xPosition="before" class="context-meun-dropdown">
                        <button mat-menu-item (click)="viewOrderDetail(element,false,'placed')">View Order</button>
                        <button mat-menu-item (click)="emailOrderDetail(element)">Email Order</button>
                        <button mat-menu-item (click)="generatePdf(element)">Download PDF</button>
                      </mat-menu>
                    </div>
                  </td>
                  <td mat-footer-cell *matFooterCellDef class="xs-none">  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="placedRequestColumns;sticky:true;"></tr>
                <tr mat-row *matRowDef="let row; columns: placedRequestColumns;"></tr>
              </table>
              <div *ngIf="placedRequestDataSource == undefined || placedRequestDataSource?.data.length == 0" class="noDataMsg">
                <p class="padding-b47">No Record Found.</p>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </div>
</div>
